import { render, staticRenderFns } from "./index.vue?vue&type=template&id=457420b4&scoped=true&lang=html&"
import script from "./couponStoreList.js?vue&type=script&lang=js&"
export * from "./couponStoreList.js?vue&type=script&lang=js&"
import style0 from "./couponStoreList.styl?vue&type=style&index=0&id=457420b4&lang=stylus&scoped=true&"
import style1 from "./index.vue?vue&type=style&index=1&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "457420b4",
  null
  
)

export default component.exports